


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import ChartCircTypeConst from '../../../../domain/Constants/ChartCircTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import DataSourceConst from '@ilinium/shared/src/entidades/builder/crud/infrastructure/functions/dataSourceConst';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_chart_circ',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },

    },
    setup(props, context) {
        //
        
        const store = useStore();
        const { vmodel, loaded, getPropertyValue, getPropertyBooleanValue, getCatalogValue, getPropertyNumberValue, resolveExpressions, baseOnUnmount, fieldKey, fieldKeyComponentDataSourceId,
            getComponentDataSourceItemsFromId, getComponentDataSource } = ComponentCommon(props, context,store);
        const chartData = ref();
        const chartOptions = ref();
        const backgroundColor = ref();
        const hoverBackgroundColor = ref();
        const values = ref();
        const labels = ref();
        const data = ref();

        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }
        const setChartData = () => {

            const documentStyle = getComputedStyle(document.body);

            return {
                labels: labels.value,
                datasets: [
                    {
                        data: values.value,
                        backgroundColor: backgroundColor.value,
                        hoverBackgroundColor: hoverBackgroundColor.value
                    }
                ]
            };

        };




        const setChartOptions = () => {

            return {
                plugins: {
                    legend: {
                        labels: {
                            cutout: getPropertyValue(ChartCircTypeConst.CUTOUT),
                            usePointStyle: getPropertyBooleanValue(ChartCircTypeConst.USEPOINTSTYLE),
                            color: getPropertyValue(ChartCircTypeConst.COLOR)
                        }
                    }
                }
            };

        }



        const getShortDescColumnName = (columnName: any) => {

            const cds = getComponentDataSource(ChartCircTypeConst.DATA);

            if (cds && cds.dataSource.iapDataSourceFields) {

                const dataBaseId = cds?.dataSource?.iapDataSourceDataBase?.idBaseDatos;

                const dsf = cds.dataSource.iapDataSourceFields.find(x => (dataBaseId + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columnName);

                if (dsf) {
                    return dsf.shortDescription ?? dsf.description ?? dsf.field;
                }


            }

            return columnName;
        }


        const getObjectFormatted = (_data: any) => {

            let newObject: any = {};

            for (var prop in _data) {
                if (_data.hasOwnProperty(prop)) {
                    newObject[getShortDescColumnName(prop)] = _data[prop];
                }
            }

            return newObject;
        }


        const getFirstColumnRowValues = (_data: any, colPosition: number) => {
            const rowValues =
                _data.map((obj: any) => {
                    const row = Object.values(obj)[colPosition];
                    return row;
                });


            return rowValues;
        }



        onMounted(() => {
            // resolveExpressions();
            data.value = getComponentDataSourceItemsFromId(ChartCircTypeConst.DATA);
            if (data.value) {

                if (getCatalogValue(ChartCircTypeConst.LABELDATA) == 'col') {
                    const valueFormatted = getObjectFormatted(data.value[0]);
                    values.value = Object.values(valueFormatted);
                    labels.value = Object.keys(valueFormatted);
                }
                else if (getCatalogValue(ChartCircTypeConst.LABELDATA) == 'row') {

                    labels.value = getFirstColumnRowValues(data.value, 0);
                    values.value = getFirstColumnRowValues(data.value, 1);

                }

            }
            backgroundColor.value = getPropertyValue(ChartCircTypeConst.BACKGROUNDCOLOR)?.split(';');
            hoverBackgroundColor.value = getPropertyValue(ChartCircTypeConst.HOVERBACKGROUNDCOLOR)?.split(';');
            chartData.value = setChartData();
            chartOptions.value = setChartOptions();


        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            ChartCircTypeConst,
            getPropertyNumberValue,
            loaded,
            BaseControlTypeConst,
            fieldKey,
            fieldKeyComponentDataSourceId,
            chartData,
            chartOptions,
            getCatalogValue,



        };
    },
});
